export type ExportPhase = 'creating' | 'preparing' | 'uploading' | 'success' | 'error'

export interface ExportToastState {
  visible: boolean
  phase: ExportPhase
  message?: string
  overallTotal: number
  overallDone: number
  imageTotal?: number
  imageDone?: number
  // Per-dataset/tag aggregation
  perTag?: Record<string, { done: number; total: number; color?: string }>
  // UI state
  minimized?: boolean
  error?: string
}

type Listener = (state: ExportToastState) => void

let listeners: Listener[] = []
let currentState: ExportToastState = {
  visible: false,
  phase: 'preparing',
  overallTotal: 0,
  overallDone: 0,
  imageTotal: 0,
  imageDone: 0,
  perTag: {},
  minimized: true,
}

let cancelRequested = false

export function subscribeExportProgress(listener: Listener) {
  listeners.push(listener)
  // push current synchronously
  try {
    listener(currentState)
  } catch {}
  return () => {
    listeners = listeners.filter((l) => l !== listener)
  }
}

export function publishExportProgress(partial: Partial<ExportToastState>) {
  currentState = { ...currentState, ...partial }
  listeners.forEach((l) => {
    try {
      l(currentState)
    } catch {}
  })
}

export function hideExportProgress() {
  publishExportProgress({ visible: false })
}

export function requestExportCancel() {
  cancelRequested = true
  publishExportProgress({ message: 'Stopping...' })
}

export function isExportCancelRequested() {
  return cancelRequested
}

export function resetExportCancel() {
  cancelRequested = false
}
